module.exports = "../../static/fonts/fontawesome-webfont.b06871f.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1069
// module chunks = 0